export const commonLayersOptions = {
	showTiles: true,
	showInspections: true,
	showRisk: true,
	showOther: true,
};

export const geojsonRestictions = {
	radiusDefault: 5000, // m
	boundMargin: 1.02, // %
};
